/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-statements */
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import {
	BsFillArrowLeftCircleFill,
	BsFillArrowRightCircleFill
} from 'react-icons/bs';
import { useMutation, useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import validator from 'validator';
import { globalEnv } from '../../../../config/baseConfig';
import { useTypedSelector } from '../../../../hooks/useTypeSelector';
import { SetUnsavedChangesAction } from '../../../../redux/actions/globalAction';
import { SetNotificationAction } from '../../../../redux/actions/notificationAction';
import { setSelectedSection } from '../../../../redux/actions/sideBarAction';
import { DatePickerComponent } from '../../../Utils/Components/datePicker/datePicker';
import { DataNotFoundAnimation } from '../../../Utils/ErrorAnimations/dataNotFoundAnim';
import LoadingAnimComponent from '../../../Utils/LoadingAnimations/loadingAnimation';
import { stateNotificationsEnum } from '../../../Utils/notification';
import SaveButton from '../../../Utils/saveButton';
import Quote from '../quote';
import CopyToTopicModalContent from './copyImageToTopicModal';
import ParentModal from '../../../Utils/Components/parentModal';
import RemoveModal from '../../../Utils/Components/removeModal';
import axios from 'axios';
import { IDeleteMedia } from './VideoComponent';
import { Dropzone, IMAGE_MIME_TYPE } from '@mantine/dropzone';
import {
	dropzoneChildren,
	IFile,
	IUploadFile,
	readImages,
	uploadStateValues,
	uploadFilesAndGetLocation
} from '../../../Utils/upload/uploadImagesUtils';
import { useMantineTheme } from '@mantine/core';

type propsType = { isForPhone: boolean };

export function EditVideoDetails(props: propsType) {
	const [isMine, setIsMine] = useState(true);
	const [isCollaborator, setIsCollaborator] = useState(false);
	const [isChanged, setIsChanged] = useState(false);
	const [isSaving, setIsSaving] = useState(false);
	const [title, setTitle] = useState<string>();
	const [description, setDescription] = useState<string>();
	const [url, setUrl] = useState<string>();
	const [thumbnailUrl, setThumbnailUrl] = useState<string>();
	const [photographer, setPhotographer] = useState<string>();
	const [info, setInfo] = useState<string>();
	const [source, setSource] = useState<string>();
	const [location, setLocation] = useState<string>();
	const [date, setDate] = useState<Date | null>(new Date());
	const [quotes, setQuotes] = useState<any[]>([]);

	const [uploadImages, setUploadImages] = useState<IFile[]>([]);
	const [uploadFiles, setUploadFiles] = useState<IUploadFile[]>([]);

	const [nextVideoId, setNextVideoId] = useState<string | null>(null);
	const [prevVideoId, setPrevVideoId] = useState<string | null>(null);
	const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

	const [isCopyToTopicModalOpen, setIsCopyToTopicModalOpen] = useState(false);
	const [isCopyToTopicModalChanged, setIsCopyToTopicModalChanged] =
		useState(false);

	const [isWarnModalOpen, setIsWarnModalOpen] = useState(false);
	const [errorOccured, setErrorOccured] = useState(false);

	const [titleErrorMsg, setTitleErrorMsg] = useState({
		message: '',
		error: false
	});

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});

	const theme = useMantineTheme();

	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		dispatch(
			SetUnsavedChangesAction({
				unsavedChanges: isChanged
			})
		);
	}, [isChanged]);

	const dispatch = useDispatch();
	dispatch(setSelectedSection('Video Edit'));

	const { topicId, videoId } = useParams();

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);
	const { user } = useTypedSelector((state) => state.auth) as any;

	async function fetchVideoData() {
		let endpoint = `${globalEnv.BASE_URL}/topic/${topicId}/media/video/${videoId}/get-details`;
		if (props.isForPhone)
			endpoint = `${globalEnv.BASE_URL}/topic/${topicId}/media/phone-video/${videoId}/get-details`;
		const { data } = await axios.get(endpoint);
		return data;
	}

	const { data, isLoading, isFetching, isError } = useQuery(
		['video', topicId, videoId],
		() => fetchVideoData(),
		{
			keepPreviousData: true,
			refetchOnWindowFocus: false,
			staleTime: 5000
		}
	);

	const saveVideoReq = async () => {
		interface Dto {
			[key: string]: any;
		}

		const uploadedFiles = await uploadFilesAndGetLocation(
			uploadImages,
			setUploadImages,
			uploadFiles,
			title ?? 'video-untitled'
		);

		let uploadState = '';

		if (uploadedFiles.length == uploadImages.length) {
			console.log('change uploadState success');
			uploadState = uploadStateValues.SUCCESS;
		} else if (uploadedFiles.length === 0) {
			uploadState = uploadStateValues.FAILED;
		} else uploadState = uploadStateValues.PARTIAL;

		const dto: Dto = {
			title: title,
			description: description,
			info: info,
			source: source,
			videoImageUrl:
				uploadFiles.length > 0 ? uploadedFiles[0].url : thumbnailUrl,
			photographer: photographer,
			location: location,
			date: date,
			quotes: quotes,
			isPhone: props.isForPhone
		};

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const { data: response } = await axios.put(
			`${globalEnv.BASE_URL}/admin/topic/${topicId}/media/video/${videoId}/update`,
			dto,
			config
		);
		return response;
	};

	const { mutate } = useMutation(saveVideoReq, {
		onMutate: () => {
			setIsSaving(true);
		},
		onSuccess: () => {
			setIsSaving(false);
			setIsChanged(false);
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully updated video info.'
				})
			);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "Couldn't update video info."
				})
			);
			setIsSaving(false);
		}
	});

	const saveVideo = async () => {
		for (let index = 0; index < quotes.length; index++) {
			const quote = quotes[index];
			if (validator.isEmpty(quote.content, { ignore_whitespace: true })) {
				dispatch(
					SetNotificationAction({
						type: stateNotificationsEnum.ERROR,
						message: 'Please fill the empty quote fields!'
					})
				);
				return;
			}
		}
		mutate();
	};

	useEffect(() => {
		try {
			if (data != null) {
				const video = data.media[0];
				setTitle(video.title);
				setDescription(video.description);
				setUrl(video.url);
				setThumbnailUrl(video.videoImageUrl);
				setInfo(video.info);
				setLocation(video.location);
				setPhotographer(video.photographer);
				setSource(video.source);
				const tempQuotes = video.quotes;
				if (moment(video.date).isValid()) setDate(moment(video.date).toDate());

				if (data.contributors != null) {
					if (data.contributors.includes(user._id)) {
						setIsMine(true);
						setIsCollaborator(true);
					}
				} else {
					if (data.creator != null) {
						setIsMine(user._id === data.creator);
					}
				}

				if (tempQuotes.length > 0) {
					tempQuotes.forEach((quote: any, index: any) => {
						tempQuotes[index] = {
							...quote,
							index: Math.floor(Math.random() * 100000)
						};
					});
					setQuotes(tempQuotes);
				}

				const currentIdIndex = data.mediaIds.indexOf(video._id);

				if (data.mediaIds[data.mediaIds.length - 1] != video._id)
					setPrevVideoId(data.mediaIds[currentIdIndex + 1]);

				if (data.mediaIds[0] != video._id)
					setNextVideoId(data.mediaIds[currentIdIndex - 1]);
			}
		} catch (e) {
			console.log(e);
			setErrorOccured(true);
		}
	}, [data]);

	const verifTitle = (name = '') => {
		if (validator.isEmpty(name, { ignore_whitespace: true })) {
			setTitleErrorMsg({
				error: true,
				message: 'Please enter your email address'
			});
		}
	};

	const addQuote = () => {
		setQuotes([
			...quotes,
			{
				index: Math.floor(Math.random() * 100000),
				content: '',
				metadata: ''
			}
		]);
	};

	const removeVideoReq = async (data: IDeleteMedia) => {
		const params = new URLSearchParams();
		params.append('mediaId', data.mediaId);
		params.append('topicId', data.topicId);

		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};

		const { data: response } = await axios.put(
			globalEnv.BASE_URL + '/admin/topic/delete-video',
			params,
			config
		);
		return response;
	};

	const deleteVideo = useMutation(removeVideoReq, {
		onSuccess: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.SUCCESS,
					message: 'Successfully deleted video from topic.'
				})
			);
			navigate('../topic/' + topicId);
		},
		onError: () => {
			dispatch(
				SetNotificationAction({
					type: stateNotificationsEnum.ERROR,
					message: "couldn't delete video from topic."
				})
			);
		}
	});

	const removeVideo = (topicId: string, mediaId: string) => {
		deleteVideo.mutate({ topicId, mediaId });
	};

	const navigate = useNavigate();

	return (
		<div className="h-screen w-full pt-16">
			<Scrollbars autoHide>
				{isLoading || isFetching ? (
					<LoadingAnimComponent />
				) : isError || errorOccured ? (
					<div className="h-full ">
						<div className="flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<div className="w-full rounded-md mx-auto">
						<div
							className="h-16 fixed z-10 w-full md:w-[95%] dark:bg-gray-800 bg-white
						transition-all duration-500"
						>
							<div className="flex flex-row w-full ml-16  md:ml-32 mt-4">
								<div className="justify-start flex-1">
									<button
										className="btn btn-outline btn-sm mr-5 "
										type="button"
										style={{ transition: 'all .15s ease' }}
										onClick={() => navigate('../topic/' + topicId)}
									>
										Cancel
									</button>

									<button
										className={`btn btn-outline btn-sm mr-1 btn-primary`}
										type="button"
										style={{ transition: 'all .15s ease' }}
										onClick={() => {
											console.log('user', user._id);
											setIsCopyToTopicModalOpen(true);
										}}
									>
										Copy video to another topic
									</button>

									<ParentModal
										visible={isCopyToTopicModalOpen}
										setModalOpen={setIsCopyToTopicModalOpen}
										isChanged={isCopyToTopicModalChanged}
										setIsChanged={setIsCopyToTopicModalChanged}
										isWarnModalOpen={isWarnModalOpen}
										setIsWarnModalOpen={setIsWarnModalOpen}
									>
										<CopyToTopicModalContent
											editorId={user._id}
											imageId={videoId}
											topicId={topicId}
											setOpen={setIsCopyToTopicModalOpen}
										/>
									</ParentModal>
								</div>
								<div className="justify-end">
									<div>
										<RemoveModal
											title={'Remove Video'}
											text={'Are you sure you want to remove this video?'}
											setModalOpen={setIsRemoveModalOpen}
											setAction={() => {
												if (topicId != null)
													if (videoId != null) removeVideo(topicId, videoId);
											}}
											visible={isRemoveModalOpen}
										/>
									</div>

									<div className=" mr-16  md:mr-32">
										{isMine && !isCollaborator && (
											<button
												className="btn btn-outline btn-sm btn-error mr-1"
												type="button"
												style={{ transition: 'all .15s ease' }}
												onClick={() => setIsRemoveModalOpen(true)}
											>
												Delete
											</button>
										)}
										{isChanged && (
											<SaveButton
												isSaving={isSaving}
												saveFunc={() => saveVideo()}
											/>
										)}
									</div>
								</div>
							</div>
						</div>

						{nextVideoId != null && (
							<div
								className="fixed h-[80%] w-24 md:w-32 lg:w-40 mt-14 top-[50%] translate-y-[-50%] right-0 z-10 group overflow-hidden"
								style={{
									borderRadius: '250px 0 0 250px'
								}}
							>
								<div
									className="w-full h-full group-hover:bg-gray-900 transition-all duration-300 opacity-0 group-hover:opacity-60"
									style={{
										borderRadius: '250px 0 0 250px'
									}}
								/>

								<div className="group-1 w-fit h-fit">
									<BsFillArrowRightCircleFill
										size="80"
										className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]
							text-gray-100 dark:text-primary text-center cursor-pointer
							transition-all duration-300 opacity-0 group-hover:opacity-100"
										onClick={() => {
											// This ensures Quotes state is reset so the current video's quotes don't show on the next
											setQuotes([]);
											setUrl('');
											setTitle('');
											setInfo('');
											setLocation('');
											setPhotographer('');
											setSource('');
											setPrevVideoId(null);
											setNextVideoId(null);
											navigate(`./../${nextVideoId}`);
										}}
									/>

									<span
										className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										scale-0 origin-top group-1-hover:scale-100 z-30
										font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100
										top-[61%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
									>
										{'Next video'}
									</span>
								</div>
							</div>
						)}

						{prevVideoId != null && (
							<div
								className="fixed h-[80%] w-24 md:w-32 lg:w-40 mt-14 top-[50%] translate-y-[-50%] left-0 ml-16 z-10 group overflow-hidden"
								style={{
									borderRadius: '0 250px 250px 0'
								}}
							>
								<div
									className="w-full h-full  group-hover:bg-gray-900 transition-all duration-300 opacity-0 group-hover:opacity-60"
									style={{
										borderRadius: '0 250px 250px 0'
									}}
								/>

								<div className="group-1 w-fit h-fit">
									<BsFillArrowLeftCircleFill
										size="80"
										className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]
							text-gray-100 dark:text-primary text-center cursor-pointer
							transition-all duration-300 opacity-0 group-hover:opacity-100"
										onClick={() => {
											setQuotes([]);
											setUrl('');
											setTitle('');
											setInfo('');
											setLocation('');
											setPhotographer('');
											setSource('');
											setPrevVideoId(null);
											setNextVideoId(null);
											navigate(`./../${prevVideoId}`);
										}}
									/>

									<span
										className="absolute rounded-md shadow-md text-white bg-gray-900 p-2 min-w-max text-xs
										scale-0 origin-top group-1-hover:scale-100 z-30
										font-bold transition-all duration-500 opacity-0 group-1-hover:opacity-100
										top-[61%] left-[50%] translate-x-[-50%] translate-y-[-50%]"
									>
										{'Previous video'}
									</span>
								</div>
							</div>
						)}

						<form className="mx-auto w-full max-w-3xl pt-16">
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label
										className="block uppercase tracking-wide text-gray-700
											dark:text-gray-300 text-xs font-bold mb-2"
									>
										Title
									</label>
									<input
										className={`appearance-none block w-full py-3 px-4 rounded font-semibold
											text-gray-700 dark:text-white placeholder-gray-600 dark:placeholder-gray-500
											bg-stone-200 dark:bg-gray-700 border focus:outline-none transition-all duration-500
												border-stone-200 focus:border-gray-400 dark:focus:border-gray-600  ${
													titleErrorMsg.error
														? 'border-red-500'
														: 'border-gray-200 dark:border-gray-700'
												}`}
										id="grid-title"
										placeholder="Video title"
										onBlur={() => {
											verifTitle(title);
										}}
										onFocus={() => {
											setTitleErrorMsg({
												error: false,
												message: ''
											});
										}}
										onChange={(e) => {
											setTitle(e.target.value);
											setIsChanged(true);
										}}
										value={title}
									/>
									{titleErrorMsg.error ? (
										<p className="text-red-500 text-xs italic">
											Please fill out this field.
										</p>
									) : (
										<p className="text-gray-600 dark:text-gray-500 text-xs italic">
											Required
										</p>
									)}
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Info
									</label>
									<textarea
										className="inputStyle"
										id="grid-photographer"
										placeholder="Specify some details about the video"
										onChange={(e) => {
											setInfo(e.target.value);
											setIsChanged(true);
										}}
										value={info}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Location
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										placeholder="Paris, France"
										onChange={(e) => {
											setLocation(e.target.value);
											setIsChanged(true);
										}}
										value={location}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Creator
									</label>
									<input
										className="inputStyle"
										id="grid-last-name"
										type="text"
										placeholder="John Doe"
										onChange={(e) => {
											setPhotographer(e.target.value);
											setIsChanged(true);
										}}
										value={photographer}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>

							<div className="flex flex-wrap -mx-3 mb-6">
								<div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Source
									</label>
									<input
										className="inputStyle"
										id="grid-first-name"
										type="text"
										placeholder="www.example.com"
										onChange={(e) => {
											setSource(e.target.value);
											setIsChanged(true);
										}}
										value={source}
									/>
									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
								<div className="w-full md:w-1/2 px-3">
									<label className="block uppercase tracking-wide text-gray-700 dark:text-gray-300 text-xs font-bold mb-2">
										Date
									</label>

									<DatePickerComponent
										date={date}
										setDate={setDate}
										setIsChanged={setIsChanged}
									/>

									<p className="text-gray-600 dark:text-gray-500 text-xs italic">
										Optional
									</p>
								</div>
							</div>
						</form>

						{quotes.length > 0 ? (
							<div className="text-center mt-5">
								<div className="flex flex-row">
									<div className="flex-1"></div>
									<h3 className="flex-1 text-4xl font-semibold text-gray-600 dark:text-gray-500">
										QUOTES
									</h3>
									<div className="flex flex-1 justify-end">
										<button
											className="btn btn-outline btn-sm btn-primary ml-auto mt-1 mr-3 lg:mr-20"
											onClick={() => {
												addQuote();
											}}
										>
											Add Quote ➕
										</button>
									</div>
								</div>
								{quotes.map((quote, index) => (
									<Quote
										key={quote.index}
										index={index}
										id={quote._id}
										isMine={true}
										quote={quote.content}
										metadata={quote.metadata}
										quotes={quotes}
										setQuotes={setQuotes}
										setIsChanged={setIsChanged}
									/>
								))}
							</div>
						) : (
							<div className="flex flex-1 my-5">
								<button
									className="btn btn-outline btn-sm btn-primary mx-auto"
									onClick={() => {
										addQuote();
									}}
								>
									Add Quote ➕
								</button>
							</div>
						)}

						<div className="flex flex-row w-full mx-auto mt-10">
							<h3 className="flex-1 text-4xl font-semibold text-gray-600 dark:text-gray-500 text-center">
								Video thumbnail
							</h3>
						</div>
						<div className="flex flex-row w-2/3 mx-auto mb-10 gap-4 px-10">
							{thumbnailUrl && (
								<img
									src={thumbnailUrl}
									alt="Video thumbnail"
									className="rounded-xl w-56 h-64 mt-10"
								/>
							)}

							<div className="w-full mx-auto ">
								<div className="mx-auto px-4 w-full mt-10">
									<Dropzone
										className="dark:bg-gray-800 z-0 transition-all duration-500"
										onDrop={(files) => {
											setIsChanged(true);
											readImages(
												uploadImages,
												setUploadImages,
												uploadFiles,
												setUploadFiles,
												files,
												1
											);
										}}
										onReject={(files) => console.log('rejected files', files)}
										maxSize={30 * 1024 ** 2}
										accept={IMAGE_MIME_TYPE}
									>
										{(status) =>
											dropzoneChildren(
												uploadImages,
												status,
												theme,
												uploadFiles,
												setUploadFiles,
												setUploadImages,
												1
											)
										}
									</Dropzone>
								</div>
							</div>
						</div>

						<div className="w-2/3 rounded-xl overflow-hidden mx-auto mb-10">
							<video controls>
								<source src={url} type="video/mp4" />
							</video>
						</div>
					</div>
				)}
			</Scrollbars>
		</div>
	);
}
